/**
 * Tab switcher for the product page info block (Характеристики / Применение
 * и материалы / Комплектация / Доставка и сервис / Производитель).
 */
(() => {
    function bindMenu(menu) {
        if (!menu || menu.dataset.tabMenuBound === 'true') {
            return;
        }
        menu.dataset.tabMenuBound = 'true';

        const tabs = menu.querySelectorAll('[data-tab-target]');
        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const targetSelector = tab.getAttribute('data-tab-target');
                const panel = targetSelector && menu.querySelector(targetSelector);
                if (!panel) {
                    return;
                }

                tabs.forEach((t) => {
                    t.classList.remove('is-active');
                    t.setAttribute('aria-selected', 'false');
                });
                menu.querySelectorAll('.product-tab-menu__panel').forEach((p) => {
                    p.classList.remove('is-active');
                });

                tab.classList.add('is-active');
                tab.setAttribute('aria-selected', 'true');
                panel.classList.add('is-active');
            });
        });
    }

    function init(root) {
        (root || document).querySelectorAll('[data-product-tab-menu]').forEach(bindMenu);
    }

    document.addEventListener('DOMContentLoaded', () => init(document));

    // Re-initialize after the product-configuration-switcher swaps in a sibling product's content
    document.addEventListener('xtron:product-content-swapped', (event) => {
        const root = event.detail && event.detail.root;
        init(root || document);
    });
})();
